@if (isRenewal()) {
  <app-info-box-renewal
    [brandColour]="brandColour()"
    [currentStage]="currentStage()"
    [siteCount]="siteCount()"
  ></app-info-box-renewal>
} @else {
  <app-info-box-new
    [brandColour]="brandColour()"
    [currentStage]="currentStage()"
    [siteCount]="siteCount()"
  ></app-info-box-new>
}
